'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _noImagePanel = require('../../../../molecules/no-image-panel');

var _noImagePanel2 = _interopRequireDefault(_noImagePanel);

var _themeManager = require('../../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _moleculesMap = require('../../utilities/moleculesMap');

var _moleculesMap2 = _interopRequireDefault(_moleculesMap);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Organism Imports

// Molecule Imports

// Utilities Imports


var MultimediaPanelsStacked = function (_React$Component) {
  _inherits(MultimediaPanelsStacked, _React$Component);

  function MultimediaPanelsStacked() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultimediaPanelsStacked);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultimediaPanelsStacked.__proto__ || Object.getPrototypeOf(MultimediaPanelsStacked)).call.apply(_ref, [this].concat(args))), _this), _this.renderPanelType = function (items, config) {
      var theme = config.theme;

      if (items) {
        return items.map(function (properties, idx) {
          var newProps = (0, _themeManager2.default)(properties, theme);
          newProps.name = config.id;
          /*
            ***IMPORTANT***
            config.type is passed as a defaultProp by the child listed in the moleculesMap.
            When adding/using this organism, make sure to specify the type of the molecule in
            child defaultProps, see an example from moleculesMap.
          */
          var type = properties.config && properties.config.type || 'NoImagePanel';
          var Panel = _moleculesMap2.default[type];
          var key = idx;
          return _react2.default.createElement(Panel, _extends({}, newProps, { key: key, name: 'MltPnlStk' }));
        });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultimediaPanelsStacked, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config;
      var items = content.items;


      return _react2.default.createElement(
        _Panels2.default,
        this.props,
        this.renderPanelType(items, config)
      );
    }
  }]);

  return MultimediaPanelsStacked;
}(_react2.default.Component);

exports.default = MultimediaPanelsStacked;


MultimediaPanelsStacked.propTypes = _Panels2.default.propTypes;

var items = [_noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps, _noImagePanel2.default.defaultProps];
MultimediaPanelsStacked.defaultProps = (0, _clone2.default)(_Panels2.default.defaultProps);
MultimediaPanelsStacked.defaultProps.content.items = items;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/multimedia-panels-stacked/jsx/MultimediaPanelsStacked.js
// module id = 688
// module chunks = 4